import "./App.css";
import NavBar from "./components/Navbar/Navbar";
import AnimatedRoutes from "./components/AnimatedRoutes/AnimatedRoutes";
// import 'antd/dist/antd.css';
// import 'antd-country-phone-input/dist/index.css';
function App() {
  return (
    <>
      <NavBar />
      <AnimatedRoutes />
    </>
  );
}

export default App;
